import { render, staticRenderFns } from "./InsuranceDivCountViewer.vue?vue&type=template&id=2ec02cb0&scoped=true&"
import script from "./InsuranceDivCountViewer.vue?vue&type=script&lang=ts&"
export * from "./InsuranceDivCountViewer.vue?vue&type=script&lang=ts&"
import style0 from "./InsuranceDivCountViewer.vue?vue&type=style&index=0&id=2ec02cb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec02cb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VRow})
